module.exports = __webpack_public_path__ + "static/media/mockup-carteirinha-dark.eddd6be7.png";